import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CompanyGroup } from '@/types';
    import { useForm } from '@inertiajs/vue3';
    import CompanyGroupForm from '@/components/company-groups/CompanyGroupForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditCompanyGroup',
  props: {
    companyGroup: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        name: props.companyGroup.name,
        companyIds: props.companyGroup.companies.map((company) => company.id.toString()),
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.company-groups.update', props.companyGroup.id),
    "query-key": [_unref(QueryKey).COMPANY_GROUPS],
    title: "company-groups.company_groups_edit",
    "success-message": "company-groups.updated",
    "error-message": "company-groups.update.error"
  }, {
    default: _withCtx(() => [
      _createVNode(CompanyGroupForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})